import {
  ActionReducerMapBuilder,
  AsyncThunk,
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import { TerminalState } from "../types/terminalType";
import getTerminalAsync from "../../api/terminal/getTerminals";
import { IRoute } from "../../api/terminal/ITerminal";

const initialState: TerminalState = {
  routes: null,
  isLoading: false,
};

const handleAsyncThunk = <Returned, ThunkArg>(
  builder: ActionReducerMapBuilder<TerminalState>,
  thunk: AsyncThunk<Returned, ThunkArg, object>,
  process?: (
    state: TerminalState,
    action: ReturnType<typeof thunk.fulfilled>
  ) => void
) => {
  builder.addCase(thunk.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(thunk.fulfilled, (state, action) => {
    state.isLoading = false;
    if (process) process(state, action);
  });
  builder.addCase(thunk.rejected, (state) => {
    state.isLoading = false;
  });
};

export const getTerminals = createAsyncThunk(
  "terminal/getTerminals",
  async (_, thunkAPI) => {
    try {
      const routes: IRoute = await getTerminalAsync();
      thunkAPI.dispatch(setRoutes(routes));
      return routes;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const terminalSlice = createSlice({
  name: "terminal",
  initialState: initialState,
  reducers: {
    setRoutes: (state, action) => {
      state.routes = action.payload;
    },
  },
  extraReducers: (builder) => {
    handleAsyncThunk(builder, getTerminals, (state, action) => {
      state.routes = action.payload as IRoute;
    });
  },
});

export const { setRoutes } = terminalSlice.actions;

export default terminalSlice.reducer;
